<template>
  <div>
    <b-jumbotron>
      <b-row align-h="between">
        <b-col cols="3">
          <div class="headerWrapper">
            <font-awesome-layers full-width class="fa-3x headerIcon">
              <font-awesome-icon icon="square" style="color: #85458a" />
              <font-awesome-icon icon="globe" transform="shrink-7" style="color: white" />
            </font-awesome-layers>
            <div class="headline">
              <h5>Surgical Cases Card View</h5>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-jumbotron>
    <div id="caseCardViewNav">
      <b-tabs nav-class="details-nav" active-nav-item-class="navActive">
        <b-tab lazy title="STATUS">
          <b-row>
            <b-col cols="3">
              <label for="selectStatus">Status</label>
              <b-form-select id="selectStatus" v-model="selectedStatus" :options="statusOptions"></b-form-select>
            </b-col>
            <b-col cols="3" align-self="end">
              <b-button style="margin-right: 20%" class="align-bottom" variant="primary">Create Case</b-button>
            </b-col>
            <b-col cols="3">
              <label for="selectDivision">Division</label>
              <b-form-select v-model="selectedDivision" id="selectDivision" disabled>
                <b-form-select-option value="jr">Joint Replacement</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col cols="3">
              <label for="selectedBranch">Branch</label>
              <b-form-select id="selectedBranch" v-model="selectedBranch" :options="branchOptions"></b-form-select>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab lazy title="DAYS"></b-tab>
        <b-tab lazy title="REPS"></b-tab>
        <b-tab lazy title="ADVANCED SEARCH"></b-tab>
      </b-tabs>
    </div>
    <div id="cardView">
      <b-jumbotron bg-variant="light">
        <b-card-group deck v-if="this.tprs">
          <div class="cardWrapper" v-for="tpr in tprs" :key="tpr.externalReference">
            <SurgicalCasesCard :tpr="tpr" />
          </div>
        </b-card-group>
        <b-spinner
          variant="warning"
          class="m-5"
          style="width: 3rem; height: 3rem;"
          v-if="tprs && tprs.length === 0"
        />
      </b-jumbotron>
    </div>
  </div>
</template>

<script>
import SurgicalCasesCard from "@/components/SurgicalCasesCard.vue";

export default {
  data() {
    return {
      tprs: [],
      selectedStatus: "new",
      statusOptions: [
        { value: "new", text: "New" },
        { value: "requested", text: "Requested" },
        { value: "completed", text: "Completed" },
        { value: "cancelled", text: "Cancelled" }
      ],
      selectedDivision: "jr",
      selectedBranch: "northTexas",
      branchOptions: [{ value: "northTexas", text: "NORTH TEXAS-DALAS" }]
    };
  },
  methods: {
    cardClicked() {
      alert("Card Clicked");
    }
  },
  components: {
    SurgicalCasesCard
  },
  watch: {
    selectedStatus: {
      immediate: true,
      handler() {
        this.tprs = [];
        var opts = {};
        switch (this.selectedStatus) {
          case "new":
            opts.requestState = "Created";
            break;
          case "requested":
            opts.requestState = "Submitted";
            break;
          case "completed":
            opts.requestState = "TreatmentPlanAvailable";
            break;
          case "cancelled":
            opts.requestState = "Cancelled";
            break;
          default:
            break;
        }
        this.$treatmentPlanRequestsApi
          .treatmentplanrequestsGet(opts)
          .then(data => {
            this.tprs = data.filter(c => c.externalReference.startsWith("C-"));
          });
      }
    }
  },
  mounted() {}
};
</script>

<style  lang="scss">
#caseCardViewNav {
  margin: 0 1rem;
}

#buttonCreateCase {
  align-self: center;
}

.details-nav {
  border-bottom: 1px solid #d3d3d3 !important;
  height: 40px !important;
}

a {
  color: black;
}

.cardWrapper {
  margin: 10px 0px;
}

#cardView {
  margin-top: 1rem;
}

.navActive {
  border-bottom: 4px solid #ffb500 !important;
  border-left: 0px !important;
  border-top: 0px !important;
  border-right: 0px !important;
  font-weight: bold;
}
</style>